import type { Button } from '@sats-group/ui-lib/react/button/button.types';
import type { Select } from '@sats-group/ui-lib/react/select/select.types';
import type FuzzySearch from 'fuzzy-search';
import type { ValueOf } from 'type-fest';
import type { Breadcrumbs } from '~/client/components/breadcrumbs/breadcrumbs.types';
import type { DropdownWrapper } from '~/client/components/dropdown-wrapper/dropdown-wrapper.types';
import type { DynamicImage } from '~/client/components/dynamic-image/dynamic-image.types';
import type { Layout } from '~/client/components/layout/layout.types';

export const descriptionThemes = {
  column: 'column',
} as const;

export type Profile = {
  actualLevel?: string; // NOTE: Only used in enricher for filtering
  availability?: {
    day: string;
    times: string[];
  }[]; // NOTE: Only used in enricher for filtering
  club?: string; // NOTE: Only used for sorting
  clubId?: number; // NOTE: Only used in enricher for filtering
  clusterName?: string; // NOTE: Only used in enricher for filtering
  description?: string[];
  expertiseForFilter?: { id: string; name: string }[];
  goals?: {
    id: string;
    title: string;
  }[]; // NOTE: Only used in enricher for filtering
  image?: DynamicImage;
  level?: string; // NOTE: Only used for sorting
  metadata: string[];
  name: string;
  position?: string; // NOTE: Only used for sorting
  selectedFilters: string[];
  url: string;
};

export enum Sort {
  Level = 'level',
  Name = 'name',
  Club = 'club',
  Position = 'position',
}

export type ProfileFilterPage = {
  breadcrumbs?: Breadcrumbs;
  defaultItemsToShow?: number;
  descriptionTheme?: ValueOf<typeof descriptionThemes>;
  dropdownWrapper: DropdownWrapper;
  layout: Layout;
  profiles?: Profile[];
  results: string;
  searchOptions: {
    options: FuzzySearch.Options;
    searchKey: string[];
  };
  selectedFiltersLabel: string;
  showMoreButton: Button;
  sort?: Select;
  title: string;
};
